export default __webpack_public_path__ + "media/images/70-ebc0948b8a399fceabb01860ba0d5661.jpg";